import { render, staticRenderFns } from "./ItemInList.vue?vue&type=template&id=70bf4fe0&scoped=true"
import script from "./ItemInList.vue?vue&type=script&lang=js"
export * from "./ItemInList.vue?vue&type=script&lang=js"
import style0 from "./ItemInList.vue?vue&type=style&index=0&id=70bf4fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf4fe0",
  null
  
)

export default component.exports